// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kbl-btn-1 {
  background: #2a9679;
  border-radius: 10px;
  border-color: #2a9679;
  font-weight: 500;
  color: white;
  transition: 0.3s;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2) !important;
}
.kbl-btn-1:focus {
  box-shadow: 0px 0px 0px 2px rgba(42, 150, 121, 0.48);
}
.kbl-btn-1.disabled {
  pointer-events: none;
  background: #aeaeae !important;
  border-color: #aeaeae !important;
}

.kbl-btn-2 {
  background: #6564DB;
  border-radius: 10px;
  border-color: #6564DB;
  font-weight: 500;
  color: white;
  transition: 0.3s;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2) !important;
}
.kbl-btn-2:focus {
  box-shadow: 0px 0px 0px 2px rgba(101, 100, 219, 0.48);
}
.kbl-btn-2.disabled {
  pointer-events: none;
  background: #aeaeae !important;
  border-color: #aeaeae !important;
}

.kbl-btn-3 {
  background: #FAF9F6;
  border-radius: 10px;
  border-color: #FAF9F6;
  font-weight: 500;
  color: white;
  transition: 0.3s;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2) !important;
}
.kbl-btn-3:focus {
  box-shadow: 0px 0px 0px 2px rgba(250, 249, 246, 0.48);
}
.kbl-btn-3.disabled {
  pointer-events: none;
  background: #aeaeae !important;
  border-color: #aeaeae !important;
}

.kbl-btn-1:hover {
  background: #248269;
  border-color: #248269;
  color: white;
}
.kbl-btn-1:focus {
  background: #248269 !important;
  border-color: #248269 !important;
  color: white;
}

.kbl-btn-2:hover {
  background: #3c3bd1;
  border-color: #3c3bd1;
  color: white;
}
.kbl-btn-2:focus {
  background: #3c3bd1 !important;
  border-color: #3c3bd1 !important;
  color: white;
}

.kbl-btn-3:hover {
  background: #f1eee6;
  border-color: #f1eee6;
  color: white;
}
.kbl-btn-3:focus {
  background: #f1eee6 !important;
  border-color: #f1eee6 !important;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/scss/components/buttons.scss","webpack://./src/scss/globals.scss"],"names":[],"mappings":"AASE;EACE,mBALK;EAML,mBCTS;EDUT,qBAPK;EAQL,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8DAAA;AARJ;AAUI;EAEE,oDAAA;AARN;AAWI;EACE,oBAAA;EACA,8BAAA;EACA,gCAAA;AATN;;AARE;EACE,mBALK;EAML,mBCTS;EDUT,qBAPK;EAQL,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8DAAA;AAWJ;AATI;EAEE,qDAAA;AAWN;AARI;EACE,oBAAA;EACA,8BAAA;EACA,gCAAA;AAUN;;AA3BE;EACE,mBALK;EAML,mBCTS;EDUT,qBAPK;EAQL,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8DAAA;AA8BJ;AA5BI;EAEE,qDAAA;AA8BN;AA3BI;EACE,oBAAA;EACA,8BAAA;EACA,gCAAA;AA6BN;;AAtBI;EACE,mBA5BG;EA6BH,qBA7BG;EA8BH,YAAA;AAyBN;AAtBI;EACE,8BAAA;EACA,gCAAA;EACA,YAAA;AAwBN;;AAjCI;EACE,mBA5BG;EA6BH,qBA7BG;EA8BH,YAAA;AAoCN;AAjCI;EACE,8BAAA;EACA,gCAAA;EACA,YAAA;AAmCN;;AA5CI;EACE,mBA5BG;EA6BH,qBA7BG;EA8BH,YAAA;AA+CN;AA5CI;EACE,8BAAA;EACA,gCAAA;EACA,YAAA;AA8CN","sourcesContent":["@use \"sass:list\";\n@import '../colors';\n@import '../globals';\n\n\n$colors: (\"1\": $palette-1, \"2\": $palette-2, \"3\": $palette-3);\n$shades: (\"1\": $palette-1-dark, \"2\": $palette-2-dark, \"3\": $palette-3-dark);\n\n@each $num, $color in $colors {\n  .kbl-btn-#{$num} {\n    background: $color;\n    border-radius: $radius-btn;\n    border-color: $color;\n    font-weight: 500;\n    color: white;\n    transition: 0.3s;\n    box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.2)!important;\n\n    &:focus {\n      -webkit-box-shadow: 0px 0px 0px 2px rgba($color,0.48);\n      box-shadow: 0px 0px 0px 2px rgba($color,0.48);\n    }\n\n    &.disabled {\n      pointer-events: none;\n      background: #aeaeae!important;\n      border-color: #aeaeae!important;\n    }\n  }\n}\n\n@each $num, $shade in $shades {\n  .kbl-btn-#{$num} {\n    &:hover {\n      background: $shade;\n      border-color: $shade;\n      color: white;\n    }\n\n    &:focus {\n      background: $shade!important;\n      border-color: $shade!important;\n      color: white;\n    }\n  }\n}","$border-radius: 10px;\n$big-radius: 16px;\n$radius-btn: 10px;\n$nav-radius: 12px;\n\n$fw-light: 300;\n$fw-medium: 400;\n$fw-heavy: 500;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
